import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import HtmlSzerkeszto from './HtmlSzerkeszto';
import JegytipusokFul from './JegytipusokFul';
import { ikonURL, kepAtmeretezes } from '../../ikon';

// Ettől a dátumtól kezdve "nincs meghirdetve" (megegyezik a szerver Lathatosag::NEM_MEGHIRDETETT értékével).
const NEM_MEGHIRDETETT = '2999-12-31T00:00';

// "2026-10-18 12:30:00" -> "2026-10-18T12:30" (datetime-local mező)
function mezoDatum(s) {
    return s ? s.replace(' ', 'T').slice(0, 16) : '';
}

function ures(csoportID) {
    return {
        Id: null,
        Cim: '', Datumidokezdet: '', Datumidoveg: '',
        Maxferohely: '', Maxferohelyegyvevonek: 6, Rendezvenycsoportid: csoportID,
        Infohtmlhosszu: '', Infohtmlrovid: '',
        Vendegeknevszerint: false, Gombfelirat: 'Regisztrálok', Megrendelestorolheto: false,
        Adat1kell: false, Adat1neve: '', Adat1megjegyzes: '',
        Adat2kell: false, Adat2neve: '', Adat2megjegyzes: '',
        Adat3kell: false, Adat3neve: '', Adat3megjegyzes: '',
        Meghirdeteskezdete: NEM_MEGHIRDETETT,
        Iconfilename: '', Attekintosablonid: null,
        Ikon: null, IkonTorles: false,
        Jegytipusok: [],
    };
}

function szerverbol(r) {
    return Object.assign({}, r, {
        Datumidokezdet: mezoDatum(r.Datumidokezdet),
        Datumidoveg: mezoDatum(r.Datumidoveg),
        Meghirdeteskezdete: mezoDatum(r.Meghirdeteskezdete),
        Maxferohely: r.Maxferohely === null ? '' : String(r.Maxferohely),
        Ikon: null, IkonTorles: false,
        // a jegytípusok a memóriában szerkeszthetők; az _allapot jelzi, melyik változott (csak azok mennek a szerverre)
        Jegytipusok: (r.Jegytipusok || []).map(function (j) { return Object.assign({}, j, { _kulcs: 'j' + j.Id, _allapot: null }); }),
        Adat1neve: r.Adat1neve || '', Adat1megjegyzes: r.Adat1megjegyzes || '',
        Adat2neve: r.Adat2neve || '', Adat2megjegyzes: r.Adat2megjegyzes || '',
        Adat3neve: r.Adat3neve || '', Adat3megjegyzes: r.Adat3megjegyzes || '',
    });
}

function szerverre(f) {
    const adat = Object.assign({}, f, {
        Maxferohely: String(f.Maxferohely).trim() === '' ? null : Number(f.Maxferohely),
        Maxferohelyegyvevonek: Number(f.Maxferohelyegyvevonek),
        Rendezvenycsoportid: Number(f.Rendezvenycsoportid),
        Meghirdeteskezdete: f.Meghirdeteskezdete,   // üres = azonnal
    });
    if (adat.Id === null) {
        delete adat.Id;
    }
    // az ikon: csak akkor megy a szerverre, ha új kép van, vagy törlendő; a fájlnév/azonosító szerveroldali
    delete adat.Iconfilename;
    delete adat.VanIkon;
    const valtozott = (f.Jegytipusok || []).filter(function (j) { return j._allapot; }).map(function (j) {
        const t = Object.assign({}, j);
        Object.keys(t).forEach(function (k) { if (k.charAt(0) === '_') { delete t[k]; } });
        delete t.Rendezvenyid;
        if (t.Id === null) { delete t.Id; }
        return t;
    });
    if (valtozott.length > 0) {
        adat.Jegytipusok = valtozott;
    } else {
        delete adat.Jegytipusok;
    }
    if (adat.Ikon === null) {
        delete adat.Ikon;
    }
    return adat;
}

// Az információs szöveg megjelenítése (renderelt HTML, csak olvasható) és a szerkesztés gombja.
// A fülek mezői: csak olvasható (auditor) nézetben egy letiltott fieldset-ben vannak (a fülek gombjai kívül maradnak, azok működnek).
function Mezok({ csakOlvas, children }) {
    return <fieldset disabled={csakOlvas === true} className="rendezvenySzerkesztoMezok">{children}</fieldset>;
}

function HtmlMezo({ felirat, ertek, onSzerkesztes, csakOlvas }) {
    return (
        <div className="htmlMezo">
            <div className="htmlMezoFejlec">
                <span className="felirat">{felirat}</span>
                {csakOlvas ? undefined : <Button type="button" variant="outline-primary" size="sm" onClick={onSzerkesztes}>Szerkesztés</Button>}
            </div>
            {ertek.trim() === '' ?
                <div className="htmlMezoUres">Nincs megadva.</div>
                :
                <div className="htmlMezoTartalom" dangerouslySetInnerHTML={{ __html: ertek }} />
            }
        </div>
    );
}

// A rendezvény szerkesztő panelje három füllel (új rendezvény: rendezvenyID nélkül, a csoport előre kiválasztva).
// Az ikon és a review-sablon egyelőre nem szerkeszthető.
export default function RendezvenySzerkeszto({ rendezvenyID, csoportID, csoportok, callAPI, onHide, onMentve, csakOlvas }) {
    const [urlap, setUrlap] = useState(undefined);
    const [hiba, setHiba] = useState(undefined);
    const [ful, setFul] = useState('adatok');
    const [htmlSzerkesztes, setHtmlSzerkesztes] = useState(undefined);   // {mezo: 'Infohtmlrovid'|'Infohtmlhosszu', cim}
    const [sablonok, setSablonok] = useState([]);                          // a választható megrendelés-áttekintő sablonok
    const [kepDolgozik, setKepDolgozik] = useState(false);

    useEffect(() => {
        if (rendezvenyID === undefined) {
            setUrlap(ures(csoportID));
        } else {
            callAPI('General.getRendezvenySzerkesztes', { rendezvenyID: rendezvenyID }, function (resp) {
                setUrlap(szerverbol(resp.data.rendezveny));
            }, function () {
                onHide();
            });
        }
    }, []);

    useEffect(() => {
        callAPI('General.listAttekintoSablonValaszto', {}, function (resp) {
            setSablonok(resp.data.sablonok);
            // új rendezvénynél az első sablon az alapértelmezés (a szerver is ezt választaná)
            setUrlap(function (regi) {
                return regi !== undefined && regi.Attekintosablonid === null && resp.data.sablonok.length > 0
                    ? Object.assign({}, regi, { Attekintosablonid: resp.data.sablonok[0].Id }) : regi;
            });
        });
    }, []);

    // Új ikon kiválasztása: a böngésző szükség esetén átméretezi (legfeljebb 600 px); a szerverre a Mentéskor kerül.
    function onChange_ikonFajl(e) {
        const fajl = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!fajl) {
            return;
        }
        setKepDolgozik(true);
        kepAtmeretezes(fajl, 600, function (dataURL) {
            setKepDolgozik(false);
            setUrlap(function (regi) { return Object.assign({}, regi, { Ikon: dataURL, IkonTorles: false }); });
            setHiba(undefined);
        }, function (szoveg) {
            setKepDolgozik(false);
            setHiba(szoveg);
        });
    }

    // Ikon törlése: a Mentés után nem lesz ikon (a kiválasztott, még el nem mentett kép is eldobódik).
    function onClick_ikonTorles() {
        setUrlap(function (regi) { return Object.assign({}, regi, { Ikon: null, IkonTorles: regi.Iconfilename !== '' }); });
        setHiba(undefined);
    }

    function mezo(nev, ertek) {
        setUrlap(function (regi) { return Object.assign({}, regi, { [nev]: ertek }); });
        setHiba(undefined);
    }

    function onSubmit(e) {
        e.preventDefault();
        if (csakOlvas) {
            return;   // az auditor csak megtekinti a rendezvényt
        }
        callAPI('General.saveRendezveny', szerverre(urlap), function (resp) {
            onMentve(resp.data.rendezveny);
        }, function (resp) {
            setHiba(String(resp.userMsg || 'A mentés nem sikerült.'));
            return false;   // a hiba a panelben látszik
        });
    }

    return (
        <>
        <Modal show={true} onHide={onHide} size="lg" backdrop="static" dialogClassName="rendezvenySzerkesztoDialog">
            {/* noValidate: a hiányzó mezőket a szerver jelzi, mert egy másik fülön lévő mező miatt a böngésző nem tudna figyelmeztetni */}
            <Form onSubmit={onSubmit} noValidate className="rendezvenySzerkeszto">
                <Modal.Header closeButton>
                    <Modal.Title>{rendezvenyID === undefined ? 'Új rendezvény' : (csakOlvas ? 'Rendezvény megtekintése' : 'Rendezvény szerkesztése')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {urlap === undefined ? <div className="adminUres">Betöltés…</div> :
                        <Tabs activeKey={ful} onSelect={function (k) { setFul(k); }} className="mb-3">
                            <Tab eventKey="adatok" title="Adatok">
<Mezok csakOlvas={csakOlvas}>
                                <Row className="g-3">
                                    <Col md={8}>
                                        <Form.Group controlId="rsz_cim">
                                            <Form.Label>Cím</Form.Label>
                                            <Form.Control type="text" maxLength={60} value={urlap.Cim} onChange={function (e) { mezo('Cim', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group controlId="rsz_csoport">
                                            <Form.Label>Rendezvénycsoport</Form.Label>
                                            <Form.Select value={urlap.Rendezvenycsoportid} onChange={function (e) { mezo('Rendezvenycsoportid', Number(e.target.value)); }}>
                                                {csoportok.map(function (cs) { return <option key={cs.Id} value={cs.Id}>{cs.Cim}</option>; })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="rsz_kezdet">
                                            <Form.Label>Kezdés időpontja</Form.Label>
                                            <Form.Control type="datetime-local" value={urlap.Datumidokezdet} onChange={function (e) { mezo('Datumidokezdet', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="rsz_veg">
                                            <Form.Label>Vége időpontja</Form.Label>
                                            <Form.Control type="datetime-local" value={urlap.Datumidoveg} onChange={function (e) { mezo('Datumidoveg', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="rsz_maxferohely">
                                            <Form.Label>Maximális férőhely</Form.Label>
                                            <Form.Control type="number" min={0} value={urlap.Maxferohely} onChange={function (e) { mezo('Maxferohely', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="rsz_maxegyvevo">
                                            <Form.Label>Maximális férőhely egy vevőnek</Form.Label>
                                            <Form.Control type="number" min={1} value={urlap.Maxferohelyegyvevonek} onChange={function (e) { mezo('Maxferohelyegyvevonek', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Mezok></Tab>

                            <Tab eventKey="meghirdetes" title="Meghirdetés">
<Mezok csakOlvas={csakOlvas}>
                                <Form.Group controlId="rsz_meghirdetes" className="mb-4">
                                    <Form.Label>Meghirdetés kezdete</Form.Label>
                                    <div className="meghirdetesSor">
                                        <Form.Control type="datetime-local" value={urlap.Meghirdeteskezdete} onChange={function (e) { mezo('Meghirdeteskezdete', e.target.value); }} />
                                        <Button type="button" variant="outline-secondary" size="sm" onClick={function () { mezo('Meghirdeteskezdete', ''); }}>Azonnal</Button>
                                        <Button type="button" variant="outline-secondary" size="sm" onClick={function () { mezo('Meghirdeteskezdete', NEM_MEGHIRDETETT); }}>Nincs meghirdetve</Button>
                                    </div>
                                    <Form.Text muted>Ettől kezdve látják a látogatók a rendezvényt. Üresen: azonnal. Az új és a másolt rendezvények alapból nincsenek meghirdetve.</Form.Text>
                                </Form.Group>
                                <HtmlMezo csakOlvas={csakOlvas}
                                    felirat="Rövid információ"
                                    ertek={urlap.Infohtmlrovid}
                                    onSzerkesztes={function () { setHtmlSzerkesztes({ mezo: 'Infohtmlrovid', cim: 'Rövid információ' }); }} />
                                <HtmlMezo csakOlvas={csakOlvas}
                                    felirat="Hosszú információ"
                                    ertek={urlap.Infohtmlhosszu}
                                    onSzerkesztes={function () { setHtmlSzerkesztes({ mezo: 'Infohtmlhosszu', cim: 'Hosszú információ' }); }} />
                            </Mezok></Tab>

                            <Tab eventKey="ikon" title="Ikon és sablon">
<Mezok csakOlvas={csakOlvas}>
                                <Row className="g-4">
                                    <Col md={12}>
                                        <Form.Label>Ikon</Form.Label>
                                        {(function () {
                                            const forras = urlap.Ikon !== null ? urlap.Ikon
                                                : (urlap.IkonTorles || urlap.Iconfilename === '' || urlap.Id === null ? null : ikonURL(urlap.Id, urlap.Iconfilename));
                                            const vanMitTorolni = urlap.Ikon !== null || (urlap.Iconfilename !== '' && !urlap.IkonTorles);
                                            return (
                                                <div className="ikonSor">
                                                    <div className="ikonKep">
                                                        {forras !== null ?
                                                            <img src={forras} alt="A rendezvény ikonja" onError={function (e) { e.target.style.display = 'none'; }} />
                                                            : <span className="ikonNincs">Nincs ikon</span>
                                                        }
                                                    </div>
                                                    <div className="ikonMuveletek">
                                                        <Form.Control type="file" accept="image/png,image/jpeg,image/gif,image/webp" onChange={onChange_ikonFajl} disabled={kepDolgozik} />
                                                        <div className="ikonGombok">
                                                            <Button type="button" variant="outline-danger" size="sm" disabled={!vanMitTorolni} onClick={onClick_ikonTorles}>Ikon törlése</Button>
                                                            {kepDolgozik ? <span className="ikonAllapot">Átméretezés…</span> : undefined}
                                                            {urlap.Ikon !== null ? <span className="ikonAllapot">Új kép kiválasztva: a Mentés után kerül a rendezvényhez.</span> : undefined}
                                                            {urlap.IkonTorles && urlap.Ikon === null ? <span className="ikonAllapot">Az ikon a Mentés után törlődik.</span> : undefined}
                                                        </div>
                                                        <Form.Text muted>PNG, JPG, GIF vagy WEBP. Ha a kép nagyobb 600 × 600 pixelnél, a böngésző automatikusan lekicsinyíti. Új kép feltöltésekor a régi ikon törlődik.</Form.Text>
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group controlId="rsz_sablon">
                                            <Form.Label>Megrendelés-áttekintő sablon</Form.Label>
                                            <Form.Select value={urlap.Attekintosablonid === null ? '' : urlap.Attekintosablonid}
                                                onChange={function (e) { mezo('Attekintosablonid', e.target.value === '' ? null : Number(e.target.value)); }}>
                                                {urlap.Attekintosablonid === null ? <option value="">(az első sablon)</option> : undefined}
                                                {sablonok.map(function (sb) { return <option key={sb.Id} value={sb.Id}>{sb.Nev}</option>; })}
                                            </Form.Select>
                                            <Form.Text muted>Ez a sablon készíti a regisztráció áttekintő oldalát és a visszaigazoló levél részleteit. A sablonokat a Sablonok menüpontban (főadmin) lehet szerkeszteni.</Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Mezok></Tab>

                            <Tab eventKey="jegytipusok" title="Jegytípusok">
<Mezok csakOlvas={csakOlvas}>
                                <JegytipusokFul csakOlvas={csakOlvas} jegytipusok={urlap.Jegytipusok} onValtozas={function (lista) { mezo('Jegytipusok', lista); }} />
                            </Mezok></Tab>

                            <Tab eventKey="egyeb" title="Egyéb">
<Mezok csakOlvas={csakOlvas}>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Form.Group controlId="rsz_gomb">
                                            <Form.Label>Gomb felirata</Form.Label>
                                            <Form.Control type="text" maxLength={20} value={urlap.Gombfelirat} onChange={function (e) { mezo('Gombfelirat', e.target.value); }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className="kapcsolok">
                                        <Form.Check type="switch" id="rsz_nevszerint" label="Vendégek név szerint" checked={urlap.Vendegeknevszerint}
                                            onChange={function (e) { mezo('Vendegeknevszerint', e.target.checked); }} />
                                        <Form.Check type="switch" id="rsz_torolheto" label="A megrendelés törölhető" checked={urlap.Megrendelestorolheto}
                                            onChange={function (e) { mezo('Megrendelestorolheto', e.target.checked); }} />
                                    </Col>
                                </Row>

                                <div className="kertAdatok">
                                    <div className="kertAdatokCim">Kért adatok</div>
                                    {[1, 2, 3].map(function (i) {
                                        const kell = urlap['Adat' + i + 'kell'];
                                        return (
                                            <div key={i} className="kertAdat">
                                                <Form.Check type="switch" id={'rsz_adat' + i} label={i + '. adat'} checked={kell}
                                                    onChange={function (e) { mezo('Adat' + i + 'kell', e.target.checked); }} />
                                                {kell ?
                                                    <Row className="g-2 kertAdatMezok">
                                                        <Col md={5}>
                                                            <Form.Control type="text" placeholder="Név" aria-label={i + '. adat neve'} maxLength={100}
                                                                value={urlap['Adat' + i + 'neve']} onChange={function (e) { mezo('Adat' + i + 'neve', e.target.value); }} />
                                                        </Col>
                                                        <Col md={7}>
                                                            <Form.Control type="text" placeholder="Megjegyzés" aria-label={i + '. adat megjegyzése'} maxLength={255}
                                                                value={urlap['Adat' + i + 'megjegyzes']} onChange={function (e) { mezo('Adat' + i + 'megjegyzes', e.target.value); }} />
                                                        </Col>
                                                    </Row>
                                                    : undefined
                                                }
                                            </div>
                                        );
                                    })}
                                </div>
                            </Mezok></Tab>
                        </Tabs>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {hiba !== undefined ? <div className="visszajelzes hiba szerkesztoHiba">{hiba}</div> : undefined}
                    <Button type="button" variant="outline-secondary" onClick={onHide}>Bezárás</Button>
                    {csakOlvas ? undefined : <Button type="submit" variant="primary" disabled={urlap === undefined}>Mentés</Button>}
                </Modal.Footer>
            </Form>
        </Modal>

        {htmlSzerkesztes !== undefined ?
            <HtmlSzerkeszto
                cim={htmlSzerkesztes.cim}
                ertek={urlap[htmlSzerkesztes.mezo]}
                onMegse={function () { setHtmlSzerkesztes(undefined); }}
                onKesz={function (html) { mezo(htmlSzerkesztes.mezo, html); setHtmlSzerkesztes(undefined); }} />
            : undefined
        }
        </>
    );
}
